const RTL_LANGUAGE_CODES = [
  "ar",
  "fa",
  "he",
  "iw",
  "ku",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi",
];

const RTL_LANGUAGE_SET = new Set(RTL_LANGUAGE_CODES);

export const normalizeLanguageCode = (language) => {
  if (!language || typeof language !== "string") {
    return "";
  }

  return language.trim().toLowerCase().split(/[-_]/)[0];
};

export const isRtlLanguage = (language) =>
  RTL_LANGUAGE_SET.has(normalizeLanguageCode(language));

export const getLanguageDirection = (language) =>
  isRtlLanguage(language) ? "rtl" : "ltr";

